"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupKeyEnum = void 0;
var LookupKeyEnum;
(function (LookupKeyEnum) {
    LookupKeyEnum["PremiumYearly"] = "premium-yearly";
    LookupKeyEnum["PremiumYearlyAppleIap"] = "premium-yearly-apple-iap";
    LookupKeyEnum["PremiumMonthlyEur"] = "premium";
    LookupKeyEnum["PremiumMonthlyCzk"] = "premium-monthly-czk";
    LookupKeyEnum["PremiumYearlyCzk"] = "premium-yearly-czk";
    LookupKeyEnum["PremiumPlusYearlyCzk"] = "premium-plus-yearly-czk";
    LookupKeyEnum["PremiumMonthlyCzk202411"] = "premium-monthly-czk-2024-11";
    LookupKeyEnum["PremiumYearlyCzk202411"] = "premium-yearly-czk-2024-11";
    LookupKeyEnum["PremiumMonthlyCzk202605"] = "premium-monthly-czk-2026-05";
    LookupKeyEnum["PremiumHalfYearlyCzk202605"] = "premium-half-yearly-czk-2026-05";
})(LookupKeyEnum = exports.LookupKeyEnum || (exports.LookupKeyEnum = {}));
//# sourceMappingURL=lookup-key-enum.js.map